/**
 * VNEA Jersey Quantity Limiter
 * Forces junior-vnea-jersey-2026 to a max quantity of 1 in cart
 */

(function() {
  const RESTRICTED_HANDLE = 'junior-vnea-jersey-2026';
  const MAX_QTY = 1;

  function showNotice() {
    const existing = document.getElementById('vnea-qty-notice');
    if (existing) existing.remove();

    const notice = document.createElement('div');
    notice.id = 'vnea-qty-notice';
    notice.style.cssText = `
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: #c0392b;
      color: #fff;
      padding: 12px 24px;
      border-radius: 4px;
      font-size: 14px;
      z-index: 99999;
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    `;
    notice.textContent = 'This item is limited to 1 per order.';
    document.body.appendChild(notice);

    setTimeout(() => notice.remove(), 4000);
  }

  function enforceQuantityLimit() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        cart.items.forEach(item => {
          if (item.handle === RESTRICTED_HANDLE && item.quantity > MAX_QTY) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: MAX_QTY })
            })
            .then(() => {
              // Show notice immediately after API call succeeds
              showNotice();

              // Trigger cart refresh events
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              document.dispatchEvent(new CustomEvent('cart:updated'));

              setTimeout(() => {
                if (window.location.pathname === '/cart') {
                  window.location.reload();
                }
              }, 500);
            });
          }
        });
      });
  }

  // Watch for cart updates
  document.addEventListener('cart:updated', enforceQuantityLimit);
  document.addEventListener('cart:refresh', enforceQuantityLimit);

  // Run on cart page load
  if (window.location.pathname === '/cart') {
    enforceQuantityLimit();
  }

  // Intercept quantity changes
  document.addEventListener('change', function(e) {
    const input = e.target;
    if (
      input.matches('input[name="updates[]"]') ||
      input.matches('input.cart-item__qty-input') ||
      input.matches('input.qty__input') ||
      input.matches('[data-quantity-input]')
    ) {
      setTimeout(enforceQuantityLimit, 300);
    }
  });

  // Also watch for +/- button clicks in drawer
  document.addEventListener('click', function(e) {
    if (
      e.target.matches('[data-quantity-plus]') ||
      e.target.matches('[data-quantity-minus]') ||
      e.target.matches('.cart-item__qty-adjust') ||
      e.target.closest('[data-quantity-plus]') ||
      e.target.closest('[data-quantity-minus]')
    ) {
      setTimeout(enforceQuantityLimit, 600);
    }
  });

})();